import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { translation, TranslationObject } from '@containers/i18n/store/i18n.interface';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms'
import { I18nService } from '@containers/i18n/i18n.service';
import { ShowSnackbar } from '@shared/shared.actions';
import { TranslateService } from '@ngx-translate/core';
import { UpdateTranslationManualy } from '@containers/i18n/store/i18n.actions';

@Component({
  selector: 'app-translation-crud',
  templateUrl: './translation-crud.component.html',
  styleUrls: ['./translation-crud.component.css']
})
export class TranslationCrudComponent implements OnInit, OnDestroy {
  private _subs: Array<Subscription> = [];
  key: string;
  defaultTranslations: translation;
  isLoading;
  form: FormGroup
  currentLanguage: string;

  isUpdateMode: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<any>,
    private fb: FormBuilder,
    private i18nService: I18nService,
    private router: Router,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      key: ['', Validators.required],
      value: ['', Validators.required]
    })
    
    this.getParams();
  }

  ngOnDestroy(): void {
    this._subs
      .filter(sub => Boolean(sub))
      .forEach(sub => sub.unsubscribe())
  }

  getParams() {
    const paramMap$ = this.activatedRoute.paramMap;
    const queryParamMap$ = this.activatedRoute.queryParamMap;

    const s = combineLatest([paramMap$, queryParamMap$])
      .subscribe(([paramMap, queryParamMap]) => {
        if (paramMap.has('key')) {
          this.isUpdateMode = true;
          this.keyControll.setValue(paramMap.get('key'));
          this.keyControll.disable();
          this.form.updateValueAndValidity();
        }
        if (queryParamMap.has('value')) {
          this.valueControll.setValue(queryParamMap.get('value'));
          this.form.updateValueAndValidity();
        }
        this.currentLanguage = paramMap.get('iso2code')
      })

    this._subs.push(s);
  }

  onSubmit($event) {
    this.isLoading = true;
    const translation: TranslationObject = {
      key: this.keyControll.value,
      value: this.valueControll.value
    }

    this.i18nService.updateKey(translation, this.currentLanguage)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe(res => {
        this.router.navigate(['/admin/i18n', this.currentLanguage, 'crud', translation.key], { queryParams: { value: translation.value } })
        this.store.dispatch(new ShowSnackbar({ type: 'success', message: this.translateService.instant("OPERATION_FINISHED_SUCCESSFULLY") }),)
        this.store.dispatch(new UpdateTranslationManualy(this.currentLanguage));
      })
  }


  get keyControll(): AbstractControl {
    return this.form.get('key')
  }

  get valueControll(): AbstractControl {
    return this.form.get('value')
  }

}
